// extracted by mini-css-extract-plugin
export var footer = "_oh-0";
export var inherit = "_oh-1";
export var input = "_oh-2";
export var modalContent = "_oh-3";
export var quillEditor = "_oh-4";
export var subtitle = "_oh-5";